import * as ACTION_TYPES from './action-types';

export const setTheme = (theme) => (dispatch) => {
  dispatch({ type: ACTION_TYPES.SET_THEME, payload: theme });
};
